<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Сводный отчёт </h3>
      <div class="add-item-block mt-3 mb-3 d-flex justify-content-end">

        <b-button variant="success"
                  v-if="isAdmin()"
                  @click="onClickIModal()">
          Сформировать новый отчет
        </b-button>


      </div>

      <div class="filters">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="iin" class="form-label col-md-3"></label>
            <div class="col-md-9">
              <div class="input-group">
                <input class="form-control" type="text" placeholder="Поиск"
                       id="search"
                       v-model="page.filter.search"
                       style="font-style: italic;">
                <button class="btn btn-primary" type="button" @click="reloadList()">
                  Найти
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="isAdmin() || isManagerFC() || isAudit() || isUniversityManager() || isRector()">
          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="trancheYear" class="form-label col-md-3">
                Год
              </label>
              <div class="col-md-9">
                <select v-model="page.filter.trancheYear" id="trancheYear"
                        v-on:change="reloadList()"
                        class="form-select">
                  <option v-for="(year, index) in trancheYears" :key="index" :value="year">
                    {{ year }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="trancheNumber" class="form-label col-md-3">
                Номер транша
              </label>
              <div class="col-md-9">
                <select v-model="page.filter.trancheNumber" id="trancheNumber"
                        v-on:change="reloadList()"
                        class="form-select">
                  <option v-for="(trancheNumber, index) in trancheNumbers" :key="index" :value="trancheNumber">
                    {{ trancheNumber }}
                  </option>
                </select>
              </div>
            </div>
          </div>

        </div>


        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="reportStatus" class="form-label col-md-3">
              Статус
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.reportStatus" id="reportStatus"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="statusKey in Object.keys(reportStatuses)" :key="statusKey"
                        :value="statusKey">
                  {{ reportStatuses[statusKey] }}
                </option>
              </select>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-end">
      <b-button variant="success"
                v-if="isManagerFC() || isAdmin() || isAudit()"
                :disabled="items.length === 0"
                @click="onClickExportReports()">
        Экспортировать в MS Excel
      </b-button>
    </div>

    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>


      <template #head(name)="data">
        <div class="sortable-container none col-name"
             @click="onSortChanged('name')"
             :class="{'ascending': page.sort.name === 'ASC', 'descending': page.sort.name === 'DESC'}">
          Название
        </div>
      </template>
      <template #head(totalSum)="data">
        <div class="sortable-container none col-total-sum"
             @click="onSortChanged('totalSum')"
             :class="{'ascending': page.sort.totalSum === 'ASC', 'descending': page.sort.totalSum === 'DESC'}">
          Общая сумма
        </div>
      </template>

      <template #head(reportStatus)="data">
        <div class="sortable-container none col-status"
             @click="onSortChanged('reportStatus')"
             :class="{'ascending': page.sort.reportStatus === 'ASC', 'descending': page.sort.reportStatus === 'DESC'}">
          Статус
        </div>
      </template>
      <template #head(files)="data">
        <div class="col-files"></div>
      </template>
      <template #head(actions)="data" v-if="canViewRemove()">
        <div class="col-actions"></div>
      </template>


      <template #cell(name)="data">
        <div class="col-name" v-if="canViewReport(data.item)">
          <a :href="`/reports/${data.item.uuid}`">
            {{ data.item.name }}
          </a>
        </div>
        <div class="col-name" v-else>
          {{ data.item.name }}
        </div>
      </template>


      <template #cell(reportStatus)="data">
        <div class="col-status" :class="getStatusClass(data.item.reportStatus)">
          {{ translateStatus(data.item.reportStatus) }}
        </div>
      </template>
      <template #cell(files)="data">
        <div class="col-files d-inline">
          <el-button type="text" class="btn-icon btn-excel"
                     v-if="data.item.excelFileId"
                     :disabled="!data.item.excelFileId"
                     @click="onClickDownloadFile(data.item.excelFileId, data.item.name, 'xlsx')">
            <font-awesome-icon :icon="['fas', 'file-excel']"/>
          </el-button>

        </div>
      </template>
      <template #cell(actions)="data" v-if="canViewRemove()">
        <div class="action-cell">
          <b-button class="btn btn-danger btn-sm delete-button"
                    v-if="canRemove(data.item)"
                    @click="onClickRemove(data.item)">
            Удалить
          </b-button>
        </div>
      </template>
    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <!-- Modal component -->
  <b-modal v-model="showModal" title="Сформировать новый отчет" @ok="onClickGenerateReport">
    <form @submit.prevent="onClickGenerateReport" class="mb-4">
      <div class="mb-3">
        <label for="trancheYear" class="form-label">
          Год
        </label>
        <select v-model="dialog.filter.trancheYear" id="trancheYear" required
                class="form-select">
          <option v-for="(year, index) in trancheYears" :key="index" :value="year">
            {{ year }}
          </option>
        </select>
      </div>

      <div class="mb-3">
        <label for="isFirstCourse" class="form-label">
          Номер транша
        </label>
        <select v-model="dialog.filter.trancheNumber" id="trancheNumber"
                class="form-select" required>
          <option v-for="(trancheNumber, index) in trancheNumbers" :key="index" :value="trancheNumber">
            {{ trancheNumber }}
          </option>
        </select>
      </div>

      <div class="mb-3">
        <label for="trancheNumber" class="form-label">
          1 курс (новый прием)
        </label>
        <select v-model="dialog.filter.isFirstCourse" id="isFirstCourse"
                class="form-select">
          <option v-for="option in yesNoList" :key="option.id"
                  :value="option.id">
            {{ option.nameRu }}
          </option>
        </select>
      </div>
    </form>
  </b-modal>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>
import summaryReportService from "@/services/summaryReportService";
import fileService from "@/services/fileService";
import VueLoading from "vue-loading-overlay";
import delegationService from "@/services/delegationService";
import settingsService from "@/services/settingsService";
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import {ReportStatusEnum} from "@/enum/ReportStatusEnum";
import xlsExportService from "@/services/xlsExportService";
import {saveAs} from "@/assets/FileSaver.min";

export default {
  components: {
    VueLoading
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      setting: {
        defaultTrancheYear: null,
        defaultTrancheNumber: null
      },
      page: {
        filter: {
          search: null,
          trancheYear: null,
          trancheNumber: null,
          reportStatus: null
        },
        sort: {
          name: null,
          reportStatus: null,
          trancheYear: null,
          trancheNumber: null,
        },
        partNumber: 1,
        countInPage: 10,
      },
      totalCount: 0,
      fields: [
        {key: 'name', label: 'Документ', sortable: true},
        {key: 'trancheYear', label: 'Год', sortable: true},
        {key: 'trancheNumber', label: 'Номер транша', sortable: true},
        {key: 'reportStatus', label: 'Статус', sortable: true},
        {key: 'files', label: 'Файлы', sortable: false},
        {key: 'actions', label: '', sortable: false}
      ],
      items: [],
      trancheYears: Array.from({length: 7}, (v, i) => 2024 + i),
      trancheNumbers: Array.from({length: 4}, (v, i) => 1 + i),
      reportStatuses: {
        QUEUED: 'В очереди на формирование отчета',
        FILES_GENERATING: 'Отчет формируется',
        FILES_GENERATED: 'Отчет сформирован', // Файлы сформированы, доступно для менеджеров вузов
        SENT_FOR_APPROVAL: 'Отправлен на согласование', // Отправлен менеджеру финансового центра
        REJECTED_BY_FINANCIAL_CENTER: 'Отклонен менеджером финансового центра', // Отклонен финансовым центром
        ERROR_ON_FILES_GENERATING: 'Возникла неизвестная ошибка при формировании файлов',
      },
      yesNoList: [
        {id: true, nameRu: "Да"},
        {id: false, nameRu: "Нет"},
      ],
      dialog: {
        filter: {
          trancheYear: null,
          trancheNumber: null,
          isFirstCourse: false
        }
      },
    };
  },
  methods: {
    init() {
      this.initSettings().then(response => {
        this.page.filter.trancheYear = this.setting.defaultTrancheYear;
        this.page.filter.trancheNumber = this.setting.defaultTrancheNumber;

        this.reloadList();
      });

    },
    async reloadList() {
      this.isLoading = true;
      const response = await summaryReportService.getAll(this.page);
      this.items = response.list;
      this.totalCount = response.count;
      this.isLoading = false;
    },

    async onClickIModal() {
      this.uploadedFile = null;

      this.dialog.filter.trancheYear = this.setting.defaultTrancheYear;
      this.dialog.filter.trancheNumber = this.setting.defaultTrancheNumber;

      this.showModal = true;
    },

    async onClickGenerateReport() {
      try {
        this.isLoading = true;

        await summaryReportService.generateReport(this.dialog.filter);

        this.reloadList();
      } catch (error) {
        if (error.response.status === 409) {
          showErrorNotify(error.response.data);
        } else {
          console.error("Ошибка при выгрузке отчета:", error);
          showErrorNotify("Ошибка при выгрузке отчета");
        }
      } finally {
        this.isLoading = false;
      }
    },
    async onClickDownloadFile(fileId, name, fileExtention) {
      try {
        await fileService.download(fileId, `${name}.${fileExtention}`);
      } catch (error) {
        console.error("Ошибка при скачивании файла:", error);
      }
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };
      this.reloadList();
    },
    translateStatus(code) {
      const status = ReportStatusEnum[code];
      if (status) {
        return status.nameRu;
      }
      return "Неизвестно";
    },
    getStatusClass(status) {
      if (status === "FILES_GENERATED") {
        return "status-generated";
      } else if (status === "FILES_GENERATING") {
        return "status-generating";
      } else if (status === "ERROR_ON_FILES_GENERATING") {
        return "status-error";
      }
      return "";
    },
    canViewRemove() {
      return this.isAdmin() ||
          ((this.isUniversityManager() || this.isRector())
          && this.setting.defaultTrancheNumber == this.page.filter.trancheNumber && this.setting.defaultTrancheYear == this.page.filter.trancheYear);

    },
    canRemove(report) {
      if (!report) {
        return false;
      }

      if (report.reportStatus === ReportStatusEnum.QUEUED.code
          || report.reportStatus === ReportStatusEnum.FILES_GENERATING.code
          || report.reportStatus === ReportStatusEnum.SENT_FOR_APPROVAL.code
          || (!this.isAdmin() && report.reportStatus === ReportStatusEnum.SIGNED_BY_RECTOR.code)) {
        return false;
      }
      return true;
    },
    async onClickRemove(item) {
      const confirmed = await confirm("Вы уверены, что хотите удалить этот отчет?");
      if (confirmed) {
        try {
          this.isLoading = true;

          await summaryReportService.deleteById(item.uuid);

          this.isLoading = false;

          this.reloadList();

          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },
    async onClickExportReports() {
      this.isLoading = true;
      const response = await xlsExportService.exportReports(this.page);
      const blob = new Blob([response], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      saveAs(blob, "document.xlsx");
      this.isLoading = false;
    },
    hasEditPermission() {
      return this.isUniversityManager();
    },
    canViewReport(report) {
      if (report.reportStatus === ReportStatusEnum.QUEUED
          || report.reportStatus === ReportStatusEnum.FILES_GENERATING) {
        return false;
      }
      return this.isUniversityManager() || this.isRector() || this.isManagerFC();
    },
    isAdmin() {
      return delegationService.isAdmin();
    },
    isManagerFC() {
      return delegationService.isManagerFC();
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    },
    isRector() {
      return delegationService.isRector();
    },
    isAudit() {
      return delegationService.isAudit();
    },
    async initSettings() {
      this.setting = await settingsService.load();
    }
  },
  mounted() {

    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

h1 {
  text-align: center;
  margin-top: 20px;
}

.col-university {
}

.col-name {
}

.col-report-type-count {
  width: 130px !important;
  text-align: center;
}

.col-total-sum {
  width: 130px !important;
}

.col-status {
  width: 200px !important;
}

.col-files {
  width: 70px !important;
}

.col-actions {
  width: 10%;
}

.btn-icon {
  font-size: 30px;
  cursor: pointer;
  transition: color 0.3s;
}

.btn-excel {
  color: green;
}

.btn-pdf {
  color: #c43838;
}


.open-modal-btn {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.open-modal-btn:hover {
  background-color: #45a049;
}

h2 {
  text-align: center;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.reports-table {
  width: 100%;
  margin: 20px 0;
  border-collapse: collapse;
}

.reports-table th,
.reports-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.reports-table th {
  background-color: #4caf50;
  color: white;
}

.active-link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
}

.active-link:hover {
  text-decoration: underline;
}

.inactive-link {
  color: gray;
}

.error-link {
  color: red;
}

.action-cell {
  display: flex;
  justify-content: flex-end;
}

.status-error {
  color: red;
}

.status-generating {
  color: #e78d29;
}

.status-generated {
  color: #267e37;
}

</style>
